import PolarisIcon from '@/components/_common/PolarisIcon';
import { Box, BoxProps } from '@mui/material';
import styled from '@emotion/styled';

type AssetIconProps = BoxProps & {
  type: string;
  withColor?: boolean;
};

const AssetIcon = ({ type, withColor = false, ...boxProps }: AssetIconProps) => {
  const fileType = type?.replace('.', '').toLowerCase();

  const getIcon = () => {
    switch (fileType) {
      case 'video':
      case 'media':
      case 'mov':
      case 'avi':
      case 'mxf':
      case 'mp4':
        return <PolarisIcon icon="video" />;
      case 'audio':
      case 'mp3':
      case 'wav':
        return <PolarisIcon icon="music" />;
      case 'image':
      case 'jpg':
      case 'jpeg':
      case 'bmp':
      case 'svg':
      case 'png':
      case 'artwork':
        return <PolarisIcon icon="image" height={16} />;
      case 'subtitle':
      case 'caption':
      case 'captions':
      case 'sub':
      case 'scc':
      case 'itt':
      case 'srt':
      case 'dfxp':
      case 'ttml':
      case 'bdn':
        return <PolarisIcon icon="subtitle" />;
      case 'pdf':
        return <PolarisIcon icon="pdf" />;
      case 'xml':
        return <PolarisIcon icon="xml" />;
      case 'json':
        return <PolarisIcon icon="json" />;
      case 'document':
      case 'other':
      case 'txt':
      case 'metadata':
        return <PolarisIcon icon="file" height={17} />;
      case 'prproj':
        return <PolarisIcon icon="premier_pro" height={15} />;
      default:
        return <PolarisIcon icon="question" />;
    }
  };

  return (
    <StyledBox type={withColor ? type : undefined} {...boxProps}>
      {getIcon()}
    </StyledBox>
  );
};

export default AssetIcon;

const StyledBox = styled(Box)<{ type?: AssetIconProps['type'] }>`
  background: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme, type }) => {
    if (type === 'media') {
      return theme.palette.primary.main;
    } else if (type === 'audio') {
      return theme.palette.secondary.main;
    } else {
      return theme.palette.default.main;
    }
  }};
  border: 1px solid ${({ theme }) => theme.palette.default.main}5a;
  border-radius: 50%;
  width: 30px;
  min-width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${({ theme }) => theme.spacing(1.5)};
  transform: scale(1.1);

  & svg {
    font-size: 1.2rem;
  }
`;
